import { render, staticRenderFns } from "./DashboardPage.html?vue&type=template&id=0138e328&scoped=true&"
import script from "./DashboardPage.js?vue&type=script&lang=js&"
export * from "./DashboardPage.js?vue&type=script&lang=js&"
import style0 from "./DashboardPage.scss?vue&type=style&index=0&id=0138e328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138e328",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
